// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__Kh1c-","productName":"Table_productName__3KgvG"};